module.exports = __webpack_public_path__ + "media/images/proof_links/netflix-2f9de87f41edb4c2eeb8bfd28c064abe.svg";